/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Connection_Issue_DescriptionInputs */

const en_dialog_connection_issue_description = /** @type {(inputs: Dialog_Connection_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connection timed out or network unstable. Please check your network and try again.`)
};

const ar_dialog_connection_issue_description = /** @type {(inputs: Dialog_Connection_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتهت مهلة الاتصال أو أن الشبكة غير مستقرة. يرجى التحقق من الشبكة والمحاولة مرة أخرى.`)
};

const de_dialog_connection_issue_description = /** @type {(inputs: Dialog_Connection_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindung abgelaufen oder Netzwerk instabil. Bitte überprüfen Sie Ihr Netzwerk und versuchen Sie es erneut.`)
};

const es_dialog_connection_issue_description = /** @type {(inputs: Dialog_Connection_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La conexión se ha interrumpido o la red es inestable. Comprueba tu red e inténtalo de nuevo.`)
};

const fr_dialog_connection_issue_description = /** @type {(inputs: Dialog_Connection_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La connexion a expiré ou le réseau est instable. Veuillez vérifier votre connexion et réessayer.`)
};

const it_dialog_connection_issue_description = /** @type {(inputs: Dialog_Connection_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connessione scaduta o rete instabile. Controlla la tua connessione di rete e riprova.`)
};

const ja_dialog_connection_issue_description = /** @type {(inputs: Dialog_Connection_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続がタイムアウト、またはネットワークが不安定です。ネットワークを確認して再度お試しください。`)
};

const ko_dialog_connection_issue_description = /** @type {(inputs: Dialog_Connection_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연결 시간이 초과되었거나 네트워크가 불안정해요. 네트워크를 확인한 뒤 다시 시도해 주세요.`)
};

const pt_br_dialog_connection_issue_description = /** @type {(inputs: Dialog_Connection_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo de conexão esgotado ou rede instável. Confira sua rede e tente novamente.`)
};

const ru_dialog_connection_issue_description = /** @type {(inputs: Dialog_Connection_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время соединения истекло или нестабильное подключение. Проверьте подключение и повторите попытку.`)
};

const th_dialog_connection_issue_description = /** @type {(inputs: Dialog_Connection_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเชื่อมต่อหมดเวลาหรือเครือข่ายไม่เสถียร โปรดตรวจสอบเครือข่ายและลองอีกครั้ง`)
};

const tr_dialog_connection_issue_description = /** @type {(inputs: Dialog_Connection_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bağlantı zaman aşımına uğradı veya ağda sorun var. Lütfen ağı kontrol edip tekrar dene.`)
};

const zh_cn_dialog_connection_issue_description = /** @type {(inputs: Dialog_Connection_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连接超时或网络不稳，请检查网络后再试一次。`)
};

const zh_tw_dialog_connection_issue_description = /** @type {(inputs: Dialog_Connection_Issue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連線逾時或網路不穩，請檢查網路後再試一次。`)
};

/**
* | output |
* | --- |
* | "Connection timed out or network unstable. Please check your network and try again." |
*
* @param {Dialog_Connection_Issue_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_connection_issue_description = /** @type {((inputs?: Dialog_Connection_Issue_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Connection_Issue_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_connection_issue_description(inputs)
	if (locale === "ar") return ar_dialog_connection_issue_description(inputs)
	if (locale === "de") return de_dialog_connection_issue_description(inputs)
	if (locale === "es") return es_dialog_connection_issue_description(inputs)
	if (locale === "fr") return fr_dialog_connection_issue_description(inputs)
	if (locale === "it") return it_dialog_connection_issue_description(inputs)
	if (locale === "ja") return ja_dialog_connection_issue_description(inputs)
	if (locale === "ko") return ko_dialog_connection_issue_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_connection_issue_description(inputs)
	if (locale === "ru") return ru_dialog_connection_issue_description(inputs)
	if (locale === "th") return th_dialog_connection_issue_description(inputs)
	if (locale === "tr") return tr_dialog_connection_issue_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_connection_issue_description(inputs)
	return zh_tw_dialog_connection_issue_description(inputs)
});